import React from 'react'
import { Button, notification, Upload, UploadProps } from 'antd'
import { AntdForm } from '@/common/components/AntdForm/index.tsx'
import { AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { read } from '@e965/xlsx'

const uploadButtonProps: UploadProps = {
  maxCount: 1,
  showUploadList: true,
  beforeUpload: () => false,
  multiple: false,
  accept: '.xlsx',
}

type AntdFormExcelInputProps = {
  buttonText?: string
  onWorkSheetsListChange?: (val: string[]) => void
} & AntdFormItemProps

const getSheetNames = async (excelFile: File) => {
  if (!excelFile) return []
  try {
    const workbook = read(await excelFile.arrayBuffer())
    return workbook.SheetNames
  } catch (e: unknown) {
    if ((e as Error)?.message === 'File is password-protected') {
      notification.error({ message: 'Cannot import excel. Please remove the password before resubmit' })
      return []
    }
    throw e
  }
}

export const AntdFormExcelInput: React.FC<AntdFormExcelInputProps> = ({
  fieldProps,
  buttonText,
  onWorkSheetsListChange,
}) => {
  return (
    <AntdForm.Item
      {...fieldProps}
      valuePropName="fileList"
      getValueFromEvent={e => e.fileList}
    >
      <Upload
        {...uploadButtonProps}
        onChange={onWorkSheetsListChange
          ? async info => onWorkSheetsListChange(await getSheetNames(info.fileList[0]?.originFileObj as unknown as File))
          : undefined}
      >
        <Button htmlType="button">{buttonText || 'Select Excel File (.xlsx)'}</Button>
      </Upload>
    </AntdForm.Item>
  )
}